import { Guarded, route$navigation } from ":setup/qrouter";
import { Route } from "@solidjs/router";
import { Show } from "solid-js";
import { grading$evaluation, Evaluation } from ":src/modules/grading";
import { DashboardLayout } from ":src/layouts";
import routes from "./routes";
import { checkUserToken, checkPlatformSettings, checkFlavors } from "../SHARED/guards";
import { account$signout, Profile, account$profile } from ":src/modules/account";
import { FAQInquiry, help_portal$faq_inquiry } from ":src/modules/help-portal";
import { Loader1 } from ":src/components/loaders";

export default function Evaluator() {
  const baseRoute = routes.BASE;
  return (
    <Guarded
      setup={{
        baseRoute,
        guard: {
          steps: [checkUserToken, checkPlatformSettings, checkFlavors],
        },
      }}
      components={{
        pageNotFound: () => <div>this is Evaluator page error, this page doesn't exist</div>,
        layout(props) {
          const { guard } = props;
          return (
            <Show when={!guard.loading()} fallback={<Loader1 subtitle="Evaluator" msg={guard.msg()} />}>
              <DashboardLayout
                sideNav={{
                  setup: {
                    baseRoute,
                  },
                  components: {
                    items: [
                      (props) => {
                        return (
                          <div class="flex flex-col w-full h-full overflow-y-auto overflow-x-hidden">
                            {grading$evaluation.Anchors.Side(props)}
                          </div>
                        );
                      },
                      (props) => {
                        return (
                          <div class="flex flex-col w-full h-fit border-t-2 border-brand border-solid">
                            {help_portal$faq_inquiry.Anchors.Side(props)}
                            {account$profile.Anchors.Side(props)}
                            {account$signout.Anchors.Side(props)}
                          </div>
                        );
                      },
                    ],
                  },
                }}
                children={props.children}
              />
            </Show>
          );
        },
      }}
    >
      <Route path={routes.evaluation} component={Evaluation} />
      <Route path={routes.faq_inquiry} component={FAQInquiry} />
      <Route path={[routes.profile, "/"]} component={Profile} />
    </Guarded>
  );
}
